module.exports = __webpack_public_path__ + "assets/img/LTC018.adf19327.jpg";